import { identity } from '@ipfabric/utils/utils/functions';
import { array } from 'fp-ts';
import { pipe } from 'fp-ts/lib/pipeable';
import type { TreePickerItemWithValue } from './TreePickerItem';

export const getTreePickerItemKeys = <TKey extends string>(
  item: TreePickerItemWithValue<TKey>,
  filterDisabledItems = false,
): Set<TKey> => {
  const items =
    item.children.length === 0
      ? [item.key]
      : pipe(
          item.children,
          filterDisabledItems
            ? array.filter((child) => !child.disabled)
            : identity,
          array.map((i) =>
            Array.from(getTreePickerItemKeys(i, filterDisabledItems)),
          ),
          array.flatten,
        );
  return new Set(items);
};
